import React from "react";
import InfiniteSlider, { Slide } from "../../shared/InfiniteSliders";
import useQueryDhiHome from "../hooks/useQueryDhiHome";

type HomeHeroProps = {
  children?: React.ReactNode;
};

const HomeHero: React.FC<HomeHeroProps> = () => {
  const { data: dhiHomeData } = useQueryDhiHome();
  const beritaArticlesWithPagination = dhiHomeData?.pages.flatMap(
    (page) => page.berita,
  );
  const beritaArticles = (beritaArticlesWithPagination ?? []).flatMap(
    (page) => page.data,
  );
  const beritaSlidesWithLink = beritaArticles?.map((article) => (
    <a
      className="hover:underline cursor-pointer min-w-[100vw] whitespace-nowrap h-8 flex items-center justify-center flex-shrink-0 px-2 bg-[#204d84] flex-nowrap"
      target="_blank"
      rel="noreferrer"
      href={`/newsdetail/${article.artikel_id}`}
      key={article.artikel_id}
      onClick={() => {
        window.open(`/newsdetail/${article.artikel_id}`);
      }}
    >
      {article.artikel_judul}
    </a>
  ));
  const slides: Slide[] = beritaSlidesWithLink.map((slide) => ({
    number: slide,
  }));

  return (
    <div className="bg-gray-900" data-testid="HomeHero">
      <div className="relative isolate overflow-hidden">
        <div className="relative w-full aspect-video md:aspect-[16/9] md:h-[100vh] overflow-hidden bg-black">
          <img
            src="/static/divhubinter-hero.jpg"
            alt="Divhubinter Hero"
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
          {/* Slider at the bottom */}
          <div className="absolute bottom-0 w-full z-20">
            <InfiniteSlider slides={slides} />
          </div>
        </div>
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HomeHero;
